/*
*
* File JS componente Archive Filters
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './archive-experience-filters.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const archiveExperienceFilters = () => {


    let selectTarget = document.querySelector('.target-selector #filter-select-target');

    if (!selectTarget) return;
    
    selectTarget.addEventListener('change', () => 
    {
        let target = selectTarget.value;
        let currLocation = new URL(window.location);
        let path = currLocation.pathname.split('/page/')[0];
        let newUrl = new URL(currLocation.origin + path);

        if (target == '-1') {
            window.location = newUrl.href;
        } else if (target) { 
            newUrl.searchParams.append('target', target);
            window.location = newUrl.href; // redirect
        } else {
            return false;
        }
        
    });
}

export default archiveExperienceFilters;

//--------------------------------------------------------------------//